export const BASE_URL = 'https://v2.fecom.io'
